import * as types from '../mutation-types';
import journeys from '../../api/journeys';
import _ from 'lodash';

const state = {
  selected: {
    id: null,
    journey_type_id: null,
    name: null,
    default_journey: null
  },
  journeys: [
    {
      id: null,
      journey_type_id: null,
      name: null,
      default_journey: null
    }
  ]
};

const getters = {
  Journeys: state => state.journeys,
  SelectedJourney: state => state.selected
};

const actions = {
  getJourneys({ commit }) {
    journeys.getJourneys().then(journeys => {
      commit(types.SET_JOURNEYS, journeys.data);
    });
  },
  selectJourney({ commit, dispatch }, journey) {
    commit(types.SET_SELECTED_JOURNEY, journey);
    let groups = _.orderBy(journey.question_groups, ['number'], ['asc']);
    if (!_.isUndefined(groups[0])) {
      dispatch('selectGroup', groups[0]);
    } else {
      dispatch('unsetSelectedGroup');
    }
  },
  unsetSelectedJourney({ commit, dispatch }) {
    commit(types.UNSET_SELECTED_JOURNEY);
    dispatch('unsetSelectedGroup');
  },
  updateJourney({ commit, dispatch }, { id, updates }) {
    journeys.updateJourney(id, updates).then(journey => {
      dispatch('addNotification', {
        text: 'Journey updates saved',
        bottom: true,
        left: true,
        colour: 'success'
      });
      commit(types.UPDATE_JOURNEY, journey.data);
    });
  },
  addJourney({ dispatch }, { journey }) {
    journeys.addJourney(journey).then(() => {
      dispatch('addNotification', {
        text: 'Journey added',
        bottom: true,
        left: true,
        colour: 'success'
      });
      dispatch('getJourneyTypes');
    });
  },
  attachJourneyCriteria({ commit }, { id, answerId }) {
    journeys.attachCriteria(id, answerId).then(journey => {
      commit(types.UPDATE_SELECTED_JOURNEY_CRITERIA, journey.data.criteria);
    });
  },
  detachJourneyCriteria({ commit }, { id, answerId }) {
    journeys.detachCriteria(id, answerId).then(journey => {
      commit(types.UPDATE_SELECTED_JOURNEY_CRITERIA, journey.data.criteria);
    });
  }
};

const mutations = {
  [types.SET_JOURNEYS](state, journeys) {
    state.journeys = journeys;
  },
  [types.SET_SELECTED_JOURNEY](state, journey) {
    state.selected = journey;
  },
  [types.UPDATE_JOURNEY](state, journey) {
    const index = _.findIndex(state.journeys, ['id', journey.id]);
    if (index >= 0) {
      _.merge(state.journeys[index], journey);
    }
  },
  [types.UNSET_SELECTED_JOURNEY](state) {
    state.selected = {
      id: null,
      journey_type_id: null,
      name: null,
      default_journey: null
    };
  },
  [types.UPDATE_GROUP_ORDER](state, newOrder) {
    _.forEach(newOrder, function(item) {
      const index = _.findIndex(state.selected.question_groups, ['id', item.id]);
      if (index >= 0) {
        state.selected.question_groups[index].number = item.number;
      }
    });
  },
  [types.UPDATE_SELECTED_JOURNEY_CRITERIA](state, criteria) {
    state.selected.criteria = criteria;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
